import React from 'react';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';

const appointmentTypesOption = (appointmentType) => (
  <span>
    <FontAwesome name="square" style={{ color: appointmentType.color || '#fafafa' }} />
    {` ${appointmentType.name}`}
  </span>
);

const AppointmentTypesDropdown = ({ appointmentTypes, ...props }) => (
  <Select
    optionRenderer={appointmentTypesOption}
    options={appointmentTypes}
    valueKey="id"
    valueRenderer={appointmentTypesOption}
    {...props}
  />
);

export default AppointmentTypesDropdown;
